module.exports = __webpack_public_path__ + "3912470b12070a36fb06da0f9ed41573.png";